import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinksBlockComponent } from './links-block.component';
import { LinkModule } from '../../lib/public_api';

@NgModule({
  declarations: [LinksBlockComponent],
  imports: [
    CommonModule,
    LinkModule
  ],
  exports: [LinksBlockComponent]
})
export class LinksBlockModule { }
